import { Helmet, HelmetProvider } from "react-helmet-async";
import { Reset } from "styled-reset";
import { useAppSelector } from "./app/hooks";
import { profileState } from "./app/reducers/profile-slice";
import SignInRouter from "./components/SignInRouter";
import { ProgressLoading } from "./components/loading/ProgressLoading";
import { useGetMeQuery } from "./query/user-query";
import { GlobalStyle } from "./style/globalStyle";
import { getTitle } from "./utils/get-title";
import { AuthView } from "./views/AuthView";

const App = () => {
  const { isLoggedIn } = useAppSelector(profileState);
  useGetMeQuery();

  return (
    <>
      <GlobalStyle />
      <HelmetProvider>
        <Helmet>
          <title>{getTitle()}</title>
        </Helmet>
        <Reset />
        <ProgressLoading />
        {isLoggedIn ? <SignInRouter /> : <AuthView />}
      </HelmetProvider>
    </>
  );
};

export default App;
